// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import clockCheckIcon from "@/assets/icons/clock-check.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type ClockCheckIconProps = Omit<IconProps, "name">;

export function ClockCheckIcon(props: ClockCheckIconProps): React.ReactNode {
  return <Icon name={clockCheckIcon} {...props} />;
}
